import { formatArtworkTitleForDisplay } from '@/pages/artwork/utils/artworkTitleDisplay.utils';
import { getArtworkArtistCatalogueData, getArtworkArtistDisplayName } from '@/utils/artworkArtists';

import { formatDimensionCm } from './formatters';
import { MUSEUM_LABEL_THEME_VARS } from './museumLabelThemes';

export const MUSEUM_LABEL_WIDTH_CM = 9;
export const MUSEUM_LABEL_HEIGHT_CM = 5;

// Normalise user selections so we can safely look up a predefined theme.
export function normalizeMuseumLabelPreviewKey(labelKey) {
  if (!labelKey) {
    return null;
  }

  const trimmed = String(labelKey).trim().toLowerCase();

  if (!trimmed || trimmed === 'none') {
    return null;
  }

  const underscored = trimmed.replace(/[^a-z0-9]+/g, '_');

  if (Object.prototype.hasOwnProperty.call(MUSEUM_LABEL_THEME_VARS, underscored)) {
    return underscored;
  }

  if (Object.prototype.hasOwnProperty.call(MUSEUM_LABEL_THEME_VARS, trimmed)) {
    return trimmed;
  }

  return null;
}

// Retrieve the CSS variables that theme the label.
export function getMuseumLabelThemeVars(labelKey) {
  if (!labelKey) {
    return null;
  }

  return MUSEUM_LABEL_THEME_VARS[labelKey] || null;
}

// Assemble the data object consumed by the label modal and inline preview.
export function buildMuseumLabelData({
  artworkData,
  selectedEntry,
  normalizedMuseumLabelKey,
}) {
  if (!selectedEntry || !normalizedMuseumLabelKey) {
    return null;
  }

  const artworkAbout = artworkData?.artwork_about;
  const title = formatArtworkTitleForDisplay(artworkAbout?.artwork_title);
  const artist = getArtworkArtistDisplayName(artworkData);
  const artistCatalogue = getArtworkArtistCatalogueData(artworkData);
  const birth = artistCatalogue?.artist_birth?.trim();
  const death = artistCatalogue?.artist_death?.trim();
  const year = artworkAbout?.artwork_year == null ? null : String(artworkAbout.artwork_year).trim();
  const widthLabel = formatDimensionCm(selectedEntry.width);
  const heightLabel = formatDimensionCm(selectedEntry.height);
  const dimensions = widthLabel && heightLabel ? `${widthLabel} × ${heightLabel} cm` : null;
  const editionCount = Number(selectedEntry.quantity);

  return {
    title,
    artist: artist === '-' ? null : artist,
    artistBirthYear: /^\d{4}$/.test(birth) ? birth : null,
    artistDeathYear: /^\d{4}$/.test(death) ? death : null,
    year,
    dimensions,
    editionCount: Number.isInteger(editionCount) && editionCount > 0 ? editionCount : null,
    theme: normalizedMuseumLabelKey,
  };
}
